export const LOADING = "LOADING";
export const BILLING_DETAILS = "BILLING_DETAILS";
export const INVOICES = "INVOICES";
export const PRICING_DETAILS = "PRICING_DETAILS";
export const PRICING_LOADING = "PRICING_LOADING";
